import React, {PureComponent} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import {BarChart, Bar, Cell, ResponsiveContainer} from 'recharts';
import TrendingUpIcon from 'mdi-react/TrendingUpIcon';
import TrendingDownIcon from 'mdi-react/TrendingDownIcon';


export default class MetricsGauge extends PureComponent {
    constructor(props) {
        super(props);
        this.activeIndex = -1;

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(data, index) {
        this.activeIndex = index;
        this.setState({
            activeIndex: index,
        });
    }

    commafy = (num) => {
        let str = num.toString().split('.');
        if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        return str[0];
    };

    getTrendComponent() {

        let trendIcon;
        let statClass;

        if (this.activeIndex === 0) {
            trendIcon = <span/>;
            statClass = "custom_total_stat_neutral";
        }
        else {
            trendIcon = <TrendingUpIcon className='custom-trend-icon-positive'/>;
            statClass = "custom_total_stat_positive";

            /*if (this.props.data.length > 0 && this.props.data[this.activeIndex][this.props.metricKey] > this.props.data[this.activeIndex - 1][this.props.metricKey]) {
                trendIcon = <TrendingUpIcon className='custom-trend-icon-positive'/>;
                statClass = "custom_total_stat_positive";
            }
            else {
                trendIcon = <TrendingDownIcon className='custom-trend-icon-negative'/>;
                statClass = "custom_total_stat_negative";
            }*/
        }


        var totalAmount = 0;
        for (var currDay in this.props.data) {
            totalAmount += this.props.data[currDay][this.props.metricKey];
        }

        totalAmount = this.commafy(totalAmount);

        if (this.props.metricKey.includes("Commission")) {
            totalAmount = '£' + totalAmount;
        }

        const activeItem = this.props.data[this.activeIndex];
        let res =
            <span>
                {trendIcon}
                <p className={statClass}>
                    {totalAmount}
                </p>
            </span>;

        return (res)
    }

    getActiveIndexColor() {

        if (this.activeIndex === 0) {
            return '#5b9ad1';
        }
        else {

            if (this.props.data.length > 0 && this.props.data[this.activeIndex][this.props.metricKey] > this.props.data[this.activeIndex - 1][this.props.metricKey]) {
                return '#77cf8a';
            }
            else {
                return '#ff536b';
            }
        }
    }

    render() {

        if (this.activeIndex === -1) {
            this.activeIndex = this.props.data.length - 1;
        }

        var activeIndexColor = this.getActiveIndexColor();

        return (

            <Card>
                <CardBody>
                    <div className='card__title'>
                        <h5 className='bold-text' style={{float: 'right'}}>{this.props.metricName}</h5>
                    </div>
                    <div className='dashboard__total'>
                        {this.getTrendComponent()}

                        <ResponsiveContainer height={50} className='dashboard__chart-container'>
                            <BarChart data={this.props.data}>
                                <Bar dataKey={this.props.metricKey} onClick={this.handleClick}>
                                    {
                                        this.props.data.map((entry, index) => (
                                            <Cell cursor='pointer'
                                                  fill={index === this.activeIndex ? activeIndexColor : '#5b9ad1'}
                                                  key={`cell-${index}`}/>
                                        ))
                                    }
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </CardBody>
            </Card>

        )
    }
}

